import '@/utilities/scroll-to'

import Events from '@utilities/events'
import ScreenDimensions from '@utilities/screen-dimensions'

const HOOK_IM_REGION_LINKS = '[js-hook-interactive-map-region-link]'
const HOOK_IM_SECTOR_SELECT = '[js-hook-interactive-map-sector-select]'
const HOOK_IM_MAP = '[js-hook-interactive-map-map]'

const CLASS_IM_REGION_ON_HOVER = 'on--hover'
const CLASS_IM_REGION_IS_ACTIVE = 'is--active'
const CLASS_IM_LINK_IS_ACTIVE = 'is--active'
const CLASS_IM_CONTENT_IS_ACTIVE = 'is--active'

class InteractiveMap {
  constructor(element) {
    this.element = element
    this.map = this.element.querySelector(HOOK_IM_MAP)
    this.links = [...this.element.querySelectorAll(HOOK_IM_REGION_LINKS)]
    this.sectorSelect = this.element.querySelector(HOOK_IM_SECTOR_SELECT)

    this.createRegister().then(() => {
      this.bindEvents()
      this.setActiveRegion('nl_all')
    })
  }

  bindEvents() {
    Object.entries(this.regions).forEach(([id, region]) => {
      region.link.addEventListener('mouseenter', e => this.handleLinkMouseEvent(e, true))
      region.link.addEventListener('focus', e => this.handleLinkMouseEvent(e, true))
      region.link.addEventListener('mouseleave', e => this.handleLinkMouseEvent(e, false))
      region.link.addEventListener('blur', e => this.handleLinkMouseEvent(e, false))
      region.link.addEventListener('click', e => this.handleLinkClickEvent(e))

      Events.$on(`interactiveMap::onRegionClick[${id}]`, () => {
        if (!region.link.hasAttribute('disabled')) {
          this.setActiveRegion(id)
        }
      })
    })

    this.sectorSelect.addEventListener('change', () => this.handleRegionSelectChange())
  }

  createRegister() {
    return new Promise(resolve => {
      this.regions = {}

      this.links.forEach(link => {
        const id = link.getAttribute('aria-controls')

        if (id) {
          this.regions[id] = {
            link: link,
            mapElements: this.getpairedRegions(id),
            content: document.getElementById(`${id}--content`),
          }
        }
      })

      resolve()
    })
  }

  handleLinkMouseEvent(e, hover) {
    const region = this.regions[e.target.getAttribute('aria-controls')]
    region.mapElements?.forEach(mapElement => {
      mapElement.classList[hover ? 'add' : 'remove'](CLASS_IM_REGION_ON_HOVER)
    })
  }

  handleLinkClickEvent(e) {
    const id = e.currentTarget.getAttribute('aria-controls')
    this.setActiveRegion(id)

    if (!ScreenDimensions.isTabletPortraitAndBigger) {
      // this.map.scrollIntoView({ behavior: 'smooth', block: 'end' })
      Events.$trigger('scroll-to::scroll', {
        data: {
          target: this.map,
          scrollElement: false, // Optional, only needed when scrolling inside an element
          offset: 85, // Optional, will default to ST_OFFSET
          duration: 200, // Optional, will default to ST_DURATION
        },
      })
    }
  }

  handleRegionSelectChange() {
    const selectedSector = this.sectorSelect.options[this.sectorSelect.selectedIndex]
    const regionIDs = selectedSector.dataset.regions.split(',')

    // enable all when 'nl_all' is selected
    if (regionIDs.length === 1 && regionIDs[0] === 'nl_all') {
      Object.values(this.regions).forEach(value => {
        value.link.removeAttribute('disabled')
        value.mapElements?.forEach(mapElement => {
          mapElement.removeAttribute('disabled')
        })
      })

      this.setActiveRegion('nl_all')

      return
    }

    // Disable all
    Object.values(this.regions).forEach(value => {
      value.link.setAttribute('disabled', true)
      value.mapElements?.forEach(mapElement => {
        mapElement.setAttribute('disabled', true)
      })
    })

    // Enable selected region
    regionIDs.forEach(regionID => {
      this.regions[regionID].link.removeAttribute('disabled')

      // Exclude nl_all
      if (regionID !== 'nl_all') {
        this.regions[regionID].mapElements?.forEach(mapElement => {
          mapElement.removeAttribute('disabled')
        })
      }
    })

    this.setActiveRegion('nl_all')
  }

  setActiveRegion(id) {
    Object.entries(this.regions).forEach(([key, value]) => {
      value.link.classList[id === key ? 'add' : 'remove'](CLASS_IM_LINK_IS_ACTIVE)

      value.mapElements?.forEach(mapElement => {
        mapElement.classList[
          id === key || this.regions[id].mapElements.indexOf(mapElement) > -1 ? 'add' : 'remove'
        ](CLASS_IM_REGION_IS_ACTIVE)
      })

      value.content?.classList[(id === key ? 'add' : 'remove')](CLASS_IM_CONTENT_IS_ACTIVE)
      value.content?.setAttribute('aria-hidden', id !== key)
    })
  }

  getpairedRegions(id) {
    let regions

    switch (id) {
      case 'nl_am':
        regions = [document.getElementById('nl_am'), document.getElementById('nl_nh')]
        break
      case 'nl_rd':
        regions = [document.getElementById('nl_rd'), document.getElementById('nl_zh')]
        break
      case 'nl_th':
        regions = [document.getElementById('nl_th'), document.getElementById('nl_zh')]
        break
      case 'nl_rdth':
        regions = [
          document.getElementById('nl_rd'),
          document.getElementById('nl_th'),
          document.getElementById('nl_zh'),
        ]
        break
      case 'nl_bp':
        regions = [document.getElementById('nl_bp'), document.getElementById('nl_br')]
        break
      case 'nl_tw':
        regions = [document.getElementById('nl_tw'), document.getElementById('nl_ov')]
        break
      case 'nl_ma':
        regions = [document.getElementById('nl_ma'), document.getElementById('nl_lb')]
        break
      case 'nl_all':
        regions = [...this.element.querySelectorAll('svg path:not(.interactive-map__region--city)')]
        break
      default:
        regions = [document.getElementById(id)]
    }

    return regions
  }
}

export default InteractiveMap
